module.exports = __webpack_public_path__ + "static/media/header_projets.37389735.jpg";